module.exports = __webpack_public_path__ + "static/media/track-tool.7673fb3f.png";